/* eslint-disable @typescript-eslint/naming-convention */
import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';
import { BaseRequestModel } from '../models/base-request.model';

interface GetQuestionsRequestModel extends BaseRequestModel {
}

@injectable()
export class QuestionsApi {
    constructor(private readonly httpClient: HttpClient) {
    }

    getQuestions = async (data: GetQuestionsRequestModel, cancellationToken?: CancelToken) => {
        return this.httpClient.post<QuestionsResponseModel, GetQuestionsRequestModel>(
            '/questions',
            data,
            {
                cancelToken: cancellationToken,
            },
        );
    };
}

export interface QuestionsResponseModel {
    topics: QuestionCategoryApiModel[];
}

export interface QuestionCategoryApiModel {
    id: number;
    name: string;
    groups?: QuestionGroupApiModel[];
    description: string;
    enabled: boolean;
}

export interface QuestionGroupApiModel {
    id: string;
    name: string;
    questions: QuestionApiModel[];
}

export interface QuestionApiModel {
    id: string;
    text: string;
    entity_type: string | null;
}
